import { render, staticRenderFns } from "./ApplicantFormStep9.vue?vue&type=template&id=ae05a984&scoped=true"
import script from "./ApplicantFormStep9.vue?vue&type=script&lang=js"
export * from "./ApplicantFormStep9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae05a984",
  null
  
)

export default component.exports